import React from 'react';
import { Maximize2 } from 'lucide-react';

interface MinimizedPanel {
  id: string;
  title: string;
}

interface MinimizedBarProps {
  panels: MinimizedPanel[];
  onRestore: (panelId: string) => void;
}

export const MinimizedBar: React.FC<MinimizedBarProps> = ({ panels, onRestore }) => {
  if (panels.length === 0) return null;

  return (
    <div className="min-h-[44px] md:h-8 bg-terminal-header border-b border-terminal-border flex items-center gap-2 px-2 md:px-3 shrink-0 overflow-x-auto">
      <span className="text-[9px] text-gray-500 uppercase whitespace-nowrap">Minimized:</span>
      {panels.map(panel => (
        <button
          key={panel.id}
          onClick={() => onRestore(panel.id)}
          className="min-h-[36px] md:min-h-0 flex items-center gap-1.5 px-3 md:px-2 py-1.5 md:py-1 bg-terminal-panel border border-terminal-border rounded text-xs md:text-[10px] text-gray-400 hover:text-white hover:border-data-amber/50 active:bg-terminal-bg/50 transition-colors whitespace-nowrap"
        >
          <Maximize2 size={12} className="md:w-2.5 md:h-2.5" />
          <span>{panel.title}</span>
        </button>
      ))}
    </div>
  );
};

export default MinimizedBar;
